const LikeCounter = ({ count }) => (
  <div className="flex items-center bg-white border border-gray-300 rounded-full p-1 pr-2">
    <img
      src="https://cdn.blackincae.com/Z8H-likes-45x22.webp"
      alt="likes"
      className="h-5 w-auto"
    />
    <span className="text-[#65676B] text-[13px] ml-1">{count}</span>
  </div>
);

export default LikeCounter;
